import { motion } from 'framer-motion';
import React from 'react';

/**
 * Self-animating 3D hex emblem for the landing hero.
 * Continuous float + rotate via CSS keyframes (no interaction required),
 * plus a subtle framer-motion tilt/scale on hover.
 */
export const HeroEmblem: React.FC = () => {
  return (
    <motion.div
      className="mx-auto w-48 h-48 sm:w-60 sm:h-60"
      style={{ perspective: '1200px' }}
      whileHover={{ scale: 1.06, rotate: 2 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
    >
      <div className="hive-emblem">
        <div className="hive-emblem-ring" />
        <div className="hive-emblem-face hive-face-back" />
        <div className="hive-emblem-face hive-face-front">
          <span className="hive-emblem-glyph">◆</span>
        </div>
      </div>

      <style>{`
        .hive-emblem {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          animation: hive-float 6s ease-in-out infinite, hive-spin 16s linear infinite;
        }
        .hive-emblem-face {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          background: linear-gradient(135deg, #00e60a 0%, #00c805 45%, #00701f 80%, #001b06 100%);
          box-shadow: 0 40px 70px -25px rgba(0, 200, 5, 0.55), inset 0 0 50px rgba(255, 255, 255, 0.18);
        }
        .hive-face-front {
          transform: translateZ(28px);
        }
        .hive-face-back {
          transform: translateZ(-28px) rotateY(8deg);
          opacity: 0.5;
          filter: blur(0.5px) brightness(0.7);
        }
        .hive-emblem-glyph {
          font-size: 2.5rem;
          color: rgba(255, 255, 255, 0.35);
          transform: translateZ(4px);
        }
        .hive-emblem-ring {
          position: absolute;
          inset: -22px;
          border-radius: 9999px;
          border: 1.5px dashed rgba(0, 200, 5, 0.4);
          animation: hive-ring-spin 22s linear infinite;
        }
        @keyframes hive-float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-16px); }
        }
        @keyframes hive-spin {
          0% { transform: rotateY(0deg) rotateX(10deg); }
          100% { transform: rotateY(360deg) rotateX(10deg); }
        }
        @keyframes hive-ring-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </motion.div>
  );
};

export default HeroEmblem;
